import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/*
 * Deliberately NOT wrapped in <React.StrictMode>.
 *
 * StrictMode simulates an unmount/remount of every component on mount in dev.
 * @react-three/fiber (9.7.0, the latest) does not survive that: its Canvas
 * disposes the WebGL renderer in an effect cleanup — which calls
 * forceContextLoss() — but never resets the `root` ref it kept the renderer in.
 * On the remount the ref is still truthy, so it skips createRoot and
 * reconfigures the dead renderer. Measured result: `gl.isContextLost() === true`
 * and a 0x0 drawing buffer in dev, while the production bundle (no StrictMode)
 * renders correctly at full size.
 *
 * The cost is real — no double-render checks for accidental impurity, no
 * warnings about missing effect cleanups. If the 3D lanyard in Home ever goes
 * away, put StrictMode back.
 */
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
